import {
	Component, ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output, ViewChild
} from '@angular/core';

@Component({
	selector: 'app-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
})
export class InputComponent implements OnInit {
	@Input() value: any = '';
	@Input() type: string = 'text';
	@Input() leftIcon: string;
	@Input() rightIcon: string;
	@Input() placeholder: string = '';
	@Input() lClassName: string = "icon-size-24"
	@Input() rClassName: string = "icon-size-24"
	@Input() disabled: boolean = false
	@Input() isClose: boolean = false

	@Output() onChangeEvent = new EventEmitter<string>();
	@Output() onClickEvent = new EventEmitter<string>();
	@Output() onEnterEvent = new EventEmitter<string>();
	@Output() onFocusInEvent = new EventEmitter<string>();
	@Output() onFocusOutEvent = new EventEmitter<string>();
	@Output() onCloseEvent = new EventEmitter<void>();

	public input: string;

	constructor() {
	}

	ngOnInit(): void {
	}

	onChange(value: string) {
		this.onChangeEvent.emit(value.trim());
	}

	onClick(value: string) {
		this.onClickEvent.emit(value.trim());
	}

	onEnter(value: string) {
		this.onEnterEvent.emit(value.trim());
	}

	onFocusIn(value: string) {
		this.onFocusInEvent.emit(value.trim());
	}

	onFocusOut(value: string) {
		this.onFocusOutEvent.emit(value.trim());
	}

	onCloseClick() {
		this.onCloseEvent.emit();
	}
}
